import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { OrderProposalService } from "../../../services/api/order-proposal.service";
import { OrderProposalActions } from "../../actions/order-proposal.actions";

@Injectable()
export class SkipOrderProposalEffects {
	proposalSkippedRequested = createEffect(() => {
		return this.actions.pipe(
			ofType(OrderProposalActions.skipProposal.skip),
			switchMap((action) => {
				return this.orderProposalService.skipProposal(action.id).pipe(
					map((res) =>
						OrderProposalActions.skipProposal.skipSuccess({ id: res?.id ?? null })
					),
					catchError((error) => of(OrderProposalActions.skipProposal.skipFail({ error })))
				);
			})
		);
	});

	constructor(
		private actions: Actions,
		private orderProposalService: OrderProposalService
	) {}
}
